import React, { useState, useEffect } from "react";
import BusApiCall from "../../../../helper/axios";
import constants from "../../../../helper/constants";
import Loader from "../../../../component/loader";
import classes from "../dashboard/dashboard.module.css";
import currencyFormatter from "../../../../helper/currencyFormatter";
import {
  PartnersOnboard,
  PartnersProducts,
  PartnersOrderTotal,
  OverallCommission,
} from "../../../../component/icons/icons";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import { useTranslation } from "react-i18next";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import moment from "moment";
import UriEncode from "../../../../component/uriEncode/uriEncode";
import InfoWithMobilePopover from "../../../../component/tooltip";
import { formatNumber } from "../../../../helper/numberFormatter";

const RenderPortlet = ({
  portlet,
  duration,
  customFromDate,
  customToDate,
  fetchPortletData,
  portletData,
}) => {
  const { t } = useTranslation();
  const [count, setCount] = useState(null);
  const [loading, setLoading] = useState(true);
  const [hasTwoCounts, setHasTwoCounts] = useState(false);
  const [secondCount, setSecondCount] = useState(null);

  const [sectorList, setSectorList] = useState([]);
  const [leadSector, setleadSector] = useState("");

  const [leadSalesRepList, setleadSalesRepList] = useState([]);
  const [leadKeyAccountManager, setleadKeyAccountManager] = useState("");

  const [customerSalesRepList, setCustomerSalesRepList] = useState([]);
  const [customerKeyAccountManager, setCustomerKeyAccountManager] =
    useState("");

  const [tenantList, setTenantList] = useState([]);
  const [assocTenantId, setAssocTenantId] = useState("");

  const [ordersClosedSalesRepList, setOrdersClosedSalesRepList] = useState([]);
  const [salesRepUserId, setSalesRepUserId] = useState("");

  const [ordersTerminatedSalesRepList, setOrdersTerminatedSalesRepList] =
    useState([]);
  const [salesRepUserIdForTermination, setTerminatedOrdersSalesRepUserId] =
    useState("");

  const [salesProviderList, setSalesProviderList] = useState([]);
  const [salesProviderId, setSalesProviderId] = useState("");

  const [salesProviderIdForAccList, setSalesProviderIdForAccList] = useState(
    [],
  );
  const [salesProviderIdForAcc, setSalesProviderIdForAcc] = useState("");

  const [tenantIdListForTermination, setTenantIdListForTermination] =
    useState("");
  const [tenantIdForTermination, setTenantIdForTermination] = useState("");

  const [tenantIdListForTotalPackage, setTenantIdListForTotalPackage] =
    useState([]);
  const [tenantId, setTenantId] = useState("");

  const [partnerList, setpartnerList] = useState([]);
  const [partnerId, setPartnerId] = useState("");

  const [firstCountLabel, setFirstCountLabel] = useState("");
  const [secondCountLabel, setSecondCountLabel] = useState("");
  const [additionalCount, setAdditionalCount] = useState(false);
  const [additions, setAdditions] = useState(0);
  const [churn, setChurn] = useState(0);

  const handleLeadSectorChange = (event) => {
    setleadSector(event.target.value);
  };

  const handCustomerKeyAccountManagerChange = (event) => {
    setCustomerKeyAccountManager(event.target.value);
  };

  const handLeadKeyAccountManagerChange = (event) => {
    setleadKeyAccountManager(event.target.value);
  };

  const handAssocTenantChange = (event) => {
    setAssocTenantId(event.target.value);
  };

  const handOrdersClosedSalesRepUserIdChange = (event) => {
    setSalesRepUserId(event.target.value);
  };

  const handOrdersTerminatedSalesRepUserIdChange = (event) => {
    setTerminatedOrdersSalesRepUserId(event.target.value);
  };

  const handleSalesProviderIdChange = (event) => {
    setSalesProviderId(event.target.value);
  };

  const handleProviderIdChange = (event) => {
    setSalesProviderIdForAcc(event.target.value);
  };
  const handleTenantIdForTerminationChange = (event) => {
    setTenantIdForTermination(event.target.value);
  };
  const handlePartnerChange = (event) => {
    setPartnerId(event.target.value);
  };
  const handleTenantChange = (event) => {
    setTenantId(event.target.value);
  };

  const twoCountPortlets = {
    PartnerOrderCount: {
      firstKey: "totalOrderCount",
      secondKey: "fulfilledOrderCount",
      firstLabel: t("TOTAL"),
      secondLabel: t("FULFILLED"),
    },
    TotalOrderAndSub: {
      firstKey: "totalOrder",
      secondKey: "totalSubscription",
      firstLabel: t("ORDERS"),
      secondLabel: t("THIRD_PARTY_SUBSCRIPTIONS"),
    },
    TotalProducts: {
      firstKey: "totalOffering",
      secondKey: "totalAddon",
      firstLabel: t("OFFERINGS"),
      secondLabel: t("ADDONS"),
    },
    InvoiceStatusCount: {
      firstKey: "totalSettled",
      secondKey: "totalPending",
      firstLabel: t("SETTLED"),
      secondLabel: t("PENDING"),
    },
    TotalCustomerReq: {
      firstKey: "upgrades",
      secondKey: "downgrades",
      firstLabel: t("UPGRADES"),
      secondLabel: t("DOWNGRADES"),
    },
    TotalAccounts: {
      firstKey: "totalAccountsCount",
      secondKey: "accountsCount",
      firstLabel: t("ALL_ACCOUNTS"),
      secondLabel: t("MY_ACCOUNTS"),
    }
  };

  // useEffect(() => {
  //   if (duration === 'custom') {
  //     if (!customFromDate || !customToDate) return; // Don't fetch if dates are missing
  //     else {
  //       fetchCount();
  //     }
  //   } else {
  //     fetchCount();
  //   }
  // }, [portlet.id, duration, leadSector, leadKeyAccountManager, customerKeyAccountManager, assocTenantId, salesRepUserId, salesRepUserIdForTermination, salesProviderId, salesProviderIdForAcc, tenantIdForTermination, partnerId, tenantId]); // Re-fetch when portlet.id or duration changes

  useEffect(() => {
    if (portletData) {
      processPortletData(portletData);
    }
  }, [portletData]);

  const convertDateParam = (date) => {
    return moment(date).format("yyyy-MM-DDTHH:mm:ss:SSS+00:00");
  };

  const convertTillDateParam = (date) => {
    return moment(date).format("yyyy-MM-DDT23:59:59:999+00:00");
  };

  const processPortletData = (data) => {
    var fetchedCount = 0;
    var secondFetchedCount = 0;

    if (twoCountPortlets[portlet.id]) {
      const config = twoCountPortlets[portlet.id];
      fetchedCount = data[config.firstKey] ?? 0;
      secondFetchedCount = data[config.secondKey] ?? 0;
      setFirstCountLabel(t(config.firstLabel));
      setSecondCountLabel(t(config.secondLabel));
      setHasTwoCounts(true);
      setCount(fetchedCount);
      setSecondCount(secondFetchedCount);
    } else {
      setHasTwoCounts(false);
      setAdditionalCount(false);

      if (portlet.id == "OrderVolume") {
        fetchedCount = data.volumeMap.incomingVolume;
      } else if (portlet.id == "ProductionVolume") {
        fetchedCount = data.volumeMap.productionVolume;
      } else if (portlet.id == "ShippedOrders") {
        fetchedCount = data.volumeMap.shippedVolume;
      } else if (portlet.id == "ReturnOrders") {
        fetchedCount = data.volumeMap.returnVolume;
      } else if (portlet.id == "ProductVolume") {
        fetchedCount = data.resultData.newProductCount;
      } else if (portlet.id == "OfferingVolume") {
        fetchedCount = data.resultData.newOfferingCount;
      } else if (portlet.id == "PartnersOnboard") {
        fetchedCount = data.partnersDataMap.partnersOnboardCount;
      } else if (portlet.id == "PartnersProducts") {
        fetchedCount = data.partnersDataMap.partnersProductCount;
      } else if (portlet.id == "PartnersOrderTotal") {
        fetchedCount = data.partnersDataMap.partnersProductsOrderGrandTotal;
      } else if (portlet.id == "OverallCommission") {
        fetchedCount = data.partnersDataMap.overallCommission ?? 0;
      } else if (portlet.id == "TotalOrders") {
        fetchedCount = data.ordersCount ?? 0;
      } else if (portlet.id == "TotalOrdersFulfilled") {
        fetchedCount = data.ordersCount ?? 0;
      } else if (portlet.id == "TotalLeads") {
        if (data.sectorList) {
          setSectorList(data.sectorList);
        }
        if (data.employeeList) {
          setleadSalesRepList(data.employeeList);
        }
        fetchedCount = data.leadsCount ?? 0;
      } else if (portlet.id == "TotalCustomers") {
        if (data.employeeList) {
          setCustomerSalesRepList(data.employeeList);
        }
        const parsed = data.tenants ? JSON.parse(data.tenants) : {};
        let list = parsed?.tenants ?? [];
        setSalesProviderList(list);

        fetchedCount = data.customersCount ?? 0;
        secondFetchedCount = data.netChange ?? 0;

        setFirstCountLabel(t("TOTAL"));
        setSecondCountLabel(t("NET_CHANGE"));
        setHasTwoCounts(true);
        setSecondCount(secondFetchedCount);

        if (data.additionalCounts) {
          setAdditionalCount(true);
          setAdditions(data.additionalCounts.additions);

          if (data.additionalCounts.churns) {
            setChurn(data.additionalCounts.churns);
          }
        }
      } else if (portlet.id == "TotalFulfillmentReq") {
        fetchedCount = data.ordersCount ?? 0;
        const parsed = data.tenants ? JSON.parse(data.tenants) : {};
        let list = parsed?.tenants ?? [];
        setTenantList(list);
      } else if (portlet.id == "TotalProducts") {
        fetchedCount = data.productsCount ?? 0;
        const parsed = data.tenants ? JSON.parse(data.tenants) : {};
        let list = parsed?.tenants ?? [];
        setTenantList(list);
      } else if (portlet.id == "TotalOrdersClosed") {
        fetchedCount = data.closedOrdersCount ?? 0;
        if (data.employeeList) {
          setOrdersClosedSalesRepList(data.employeeList);
        }
      } else if (portlet.id == "TerminatedOrders") {
        fetchedCount = data.ordersCount ?? 0;
        const parsed = data.tenants ? JSON.parse(data.tenants) : {};
        let list = parsed?.tenants ?? [];
        setTenantIdListForTermination(list);
        if (data.employeeList) {
          setOrdersTerminatedSalesRepList(data.employeeList);
        }
      } else if (portlet.id == "NewAccountAdditions") {
        fetchedCount = data.newAccountsCount ?? 0;
        const parsed = data.tenants ? JSON.parse(data.tenants) : {};
        let list = parsed?.tenants ?? [];
        setSalesProviderIdForAccList(list);
      } else if (portlet.id == "TotalPackageSold") {
        fetchedCount = data.packageSoldCount ?? 0;
        const parsed = data.tenants ? JSON.parse(data.tenants) : {};
        let list = parsed.tenants ?? [];
        setTenantIdListForTotalPackage(list);
      } else if (portlet.id == "TotalClosureRate") {
        fetchedCount = data.closureRateCount ?? 0.0;
        if (fetchedCount !== 0.0) {
          // fetchedCount = fetchedCount.toFixed(2) + '%';
          fetchedCount = Math.round(fetchedCount) + "%";
        }
      } else if (portlet.id == "PartnerServicesCount") {
        fetchedCount = data.servicesCount ?? 0;
        if (data.partners) {
          setpartnerList(data.partners);
        }
      } else if (portlet.id == "PartnerSettlements") {
        fetchedCount = data.amount ?? 0;
      } else if (portlet.id == "TenantSettlements") {
        fetchedCount = data.amount ?? 0;
      } else if (portlet.id == "TotalProdRevenue") {
        fetchedCount = data.totalProductRevenue ?? 0;
      } else if (portlet.id == "DunningCount") {
        fetchedCount = data.totalDunning ?? 0;
      } else if (portlet.id == "PartnerSubCount") {
        fetchedCount = data.subscriptionCount ?? 0;
      } else if (portlet.id == "TotalSectors") {
        fetchedCount = data.sectorsCount ?? 0;
      } else if (portlet.id == "TotalAddonsCount") {
        fetchedCount = data.addons ?? 0;
      } else if (portlet.id == "TotalQuotes") {
        fetchedCount = data.quotesCount ?? 0;
      }
    }

    setCount(fetchedCount);
    if (hasTwoCounts) {
      setSecondCount(secondFetchedCount);
    }
  };

  // useEffect(() => {
  //   if (portlet.id && fetchPortletData) {
  //     fetchPortletData(portlet, duration, customFromDate, customToDate);
  //   }
  // }, [portlet.id, duration, customFromDate, customToDate]);

  const fetchCount = async () => {
    setLoading(true);
    try {
      let url = "";
      if (duration === "custom") {
        let fromDate = customFromDate
          ? encodeURIComponent(convertDateParam(customFromDate))
          : "";
        let toDate = customToDate
          ? encodeURIComponent(convertTillDateParam(customToDate))
          : "";
        url = `${constants.busInternalUrl}/graphs/${portlet.id}/records?fromDate=${fromDate}&toDate=${toDate}&leadSector=${leadSector}&leadKeyAccountManager=${leadKeyAccountManager}&customerKeyAccountManager=${customerKeyAccountManager}&assocTenantId=${assocTenantId}&salesRepUserId=${salesRepUserId}&salesRepUserIdForTermination=${salesRepUserIdForTermination}&salesProviderId=${salesProviderId}&salesProviderIdForAcc=${salesProviderIdForAcc}&tenantIdForTermination=${tenantIdForTermination}&partnerId=${partnerId}`;
      } else {
        url = `${constants.busInternalUrl}/graphs/${portlet.id}/records?duration=${duration}&leadSector=${leadSector}&leadKeyAccountManager=${leadKeyAccountManager}&customerKeyAccountManager=${customerKeyAccountManager}&assocTenantId=${assocTenantId}&salesRepUserId=${salesRepUserId}&salesRepUserIdForTermination=${salesRepUserIdForTermination}&salesProviderId=${salesProviderId}&salesProviderIdForAcc=${salesProviderIdForAcc}&tenantIdForTermination=${tenantIdForTermination}&partnerId=${partnerId}`;
      }
      const res = await BusApiCall("GET", url, {});
      var fetchedCount = 0;
      var secondFetchedCount = 0;
      if (twoCountPortlets[portlet.id]) {
        const config = twoCountPortlets[portlet.id];
        fetchedCount = res.data[config.firstKey] ?? 0;
        secondFetchedCount = res.data[config.secondKey] ?? 0;
        setFirstCountLabel(t(config.firstLabel));
        setSecondCountLabel(t(config.secondLabel));
        setHasTwoCounts(true);
        setCount(fetchedCount);
        setSecondCount(secondFetchedCount);
      } else {
        setHasTwoCounts(false);
        setAdditionalCount(false);

        if (portlet.id == "OrderVolume") {
          fetchedCount = res.data.volumeMap.incomingVolume;
        } else if (portlet.id == "ProductionVolume") {
          fetchedCount = res.data.volumeMap.productionVolume;
        } else if (portlet.id == "ShippedOrders") {
          fetchedCount = res.data.volumeMap.shippedVolume;
        } else if (portlet.id == "ReturnOrders") {
          fetchedCount = res.data.volumeMap.returnVolume;
        } else if (portlet.id == "ProductVolume") {
          fetchedCount = res.data.resultData.newProductCount;
        } else if (portlet.id == "OfferingVolume") {
          fetchedCount = res.data.resultData.newOfferingCount;
        } else if (portlet.id == "PartnersOnboard") {
          fetchedCount = res.data.partnersDataMap.partnersOnboardCount;
        } else if (portlet.id == "PartnersProducts") {
          fetchedCount = res.data.partnersDataMap.partnersProductCount;
        } else if (portlet.id == "PartnersOrderTotal") {
          fetchedCount =
            res.data.partnersDataMap.partnersProductsOrderGrandTotal;
        } else if (portlet.id == "OverallCommission") {
          fetchedCount = res.data.partnersDataMap.overallCommission ?? 0;
        } else if (portlet.id == "TotalOrders") {
          fetchedCount = res.data.ordersCount ?? 0;
        } else if (portlet.id == "TotalOrdersFulfilled") {
          fetchedCount = res.data.ordersCount ?? 0;
        } else if (portlet.id == "TotalLeads") {
          if (res.data.sectorList) {
            setSectorList(res.data.sectorList);
          }
          if (res.data.employeeList) {
            setleadSalesRepList(res.data.employeeList);
          }
          fetchedCount = res.data.leadsCount ?? 0;
        } else if (portlet.id == "TotalCustomers") {
          if (res.data.employeeList) {
            setCustomerSalesRepList(res.data.employeeList);
          }
          const parsed = res.data.tenants ? JSON.parse(res.data.tenants) : {};
          let list = parsed?.tenants ?? [];
          setSalesProviderList(list);

          fetchedCount = res.data.customersCount ?? 0;
          secondFetchedCount = res.data.netChange ?? 0;

          setFirstCountLabel(t("TOTAL"));
          setSecondCountLabel(t("NET_CHANGE"));
          setHasTwoCounts(true);
          setSecondCount(secondFetchedCount);

          if (res.data.additionalCounts) {
            setAdditionalCount(true);
            setAdditions(res.data.additionalCounts.additions);
          }
          if (res.data.additionalCounts.churns) {
            setChurn(res.data.additionalCounts.churns);
          }
        } else if (portlet.id == "TotalFulfillmentReq") {
          fetchedCount = res.data.ordersCount ?? 0;
          const parsed = res.data.tenants ? JSON.parse(res.data.tenants) : {};
          let list = parsed?.tenants ?? [];
          setTenantList(list);
        } else if (portlet.id == "TotalProducts") {
          fetchedCount = res.data.productsCount ?? 0;
          const parsed = res.data.tenants ? JSON.parse(res.data.tenants) : {};
          let list = parsed?.tenants ?? [];
          setTenantList(list);
        } else if (portlet.id == "TotalOrdersClosed") {
          fetchedCount = res.data.closedOrdersCount ?? 0;
          if (res.data.employeeList) {
            setOrdersClosedSalesRepList(res.data.employeeList);
          }
        } else if (portlet.id == "TerminatedOrders") {
          fetchedCount = res.data.ordersCount ?? 0;
          const parsed = res.data.tenants ? JSON.parse(res.data.tenants) : {};
          let list = parsed?.tenants ?? [];
          setTenantIdListForTermination(list);
          if (res.data.employeeList) {
            setOrdersTerminatedSalesRepList(res.data.employeeList);
          }
        } else if (portlet.id == "NewAccountAdditions") {
          fetchedCount = res.data.newAccountsCount ?? 0;
          const parsed = res.data.tenants ? JSON.parse(res.data.tenants) : {};
          let list = parsed?.tenants ?? [];
          setSalesProviderIdForAccList(list);
        } else if (portlet.id == "TotalPackageSold") {
          fetchedCount = res.data.packageSoldCount ?? 0;
          const parsed = res.data.tenants ? JSON.parse(res.data.tenants) : {};
          let list = parsed.tenants ?? [];
          setTenantIdListForTotalPackage(list);
        } else if (portlet.id == "TotalClosureRate") {
          fetchedCount = res.data.closureRateCount ?? 0.0;
          if (fetchedCount !== 0.0) {
            // fetchedCount = fetchedCount.toFixed(2) + '%';
            fetchedCount = Math.round(fetchedCount) + "%";
          }
        } else if (portlet.id == "PartnerServicesCount") {
          fetchedCount = res.data.servicesCount ?? 0;
          if (res.data.partners) {
            setpartnerList(res.data.partners);
          }
        } else if (portlet.id == "PartnerSettlements") {
          fetchedCount = res.data.amount ?? 0;
        } else if (portlet.id == "TenantSettlements") {
          fetchedCount = res.data.amount ?? 0;
        } else if (portlet.id == "TotalProdRevenue") {
          fetchedCount = res.data.totalProductRevenue ?? 0;
        } else if (portlet.id == "DunningCount") {
          fetchedCount = res.data.totalDunning ?? 0;
        } else if (portlet.id == "PartnerSubCount") {
          fetchedCount = res.data.subscriptionCount ?? 0;
        } else if (portlet.id == "TotalSectors") {
          fetchedCount = res.data.sectorsCount ?? 0;
        }
        setCount(fetchedCount);
      }
    } catch (error) {
      console.error("Error fetching count:", error);
      setCount(0);
    } finally {
      setLoading(false);
    }
  };

  // if (loading) {
  //   return <Loader loading={loading} />;
  // }

  return (
    <div
      className={"roundCorners borderOutline"}
      style={{ background: "white" }}
    >
      <div className={classes.screenlet_body}>
        {portlet.id === "TotalLeads" ||
        portlet.id === "TotalCustomers" ||
        portlet.id === "TotalFulfillmentReq" ||
        portlet.id === "TotalProducts" ||
        portlet.id === "TotalOrdersClosed" ||
        portlet.id === "TerminatedOrders" ||
        portlet.id === "NewAccountAdditions" ||
        portlet.id == "TotalPackageSold" ||
        portlet.id == "PartnerServicesCount" ||
        portlet.id == "TotalClosureRate" ||
        portlet.id == "PartnerOrderCount" ? (
          <>
            <div
              className={`${classes.dflex_between_center} ${classes.gap_column}`}
            >
              <div style={{ flex: 1 }}>
                <p
                  className={
                    // classes.graph_name
                    classes.graph_description
                  }
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    color: "inherit",
                  }}
                >
                  {portlet.name}
                  {/* <Tooltip title={portlet.description} arrow>
                    <span style={{ display: 'inline-flex', alignItems: 'center', marginLeft: '4px', cursor: 'pointer' }}>
                      <InfoOutlinedIcon fontSize="small" style={{ color: 'inherit', fontSize: 16, verticalAlign: 'middle' }} />
                    </span>
                  </Tooltip> */}
                  <InfoWithMobilePopover description={portlet.description} />
                </p>
              </div>
              {portlet.id === "TotalLeads" && (
                <>
                  {sectorList && sectorList.length > 0 && (
                    <div className={classes.dflex_justify_align_items}>
                      {/* <label className={classes.dashboard_label}>Sectors</label> */}
                      {/* <select name="leadSector" value={leadSector} onChange={handleLeadSectorChange}>
                        <option value="All">All</option>
                        {sectorList.map((type) => (
                          <option key={type} value={type}>
                            {type}
                          </option>
                        ))}
                      </select> */}
                      <FormControl
                        variant="outlined"
                        className="custom-select-input"
                        size={"small"}
                        style={{ width: "150px" }}
                      >
                        <InputLabel id="leadSectorType">
                          {t("SECTORS")}
                        </InputLabel>
                        <Select
                          native
                          value={leadSector}
                          onChange={handleLeadSectorChange}
                          name="leadSector"
                          label="Sectors"
                          labelId="leadSectorType"
                          inputProps={{
                            id: "leadSector",
                          }}
                        >
                          <option value="All">All</option>
                          {sectorList.map((type) => (
                            <option key={type} value={type}>
                              {type}
                            </option>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  )}

                  {leadSalesRepList && leadSalesRepList.length > 0 && (
                    <div className={classes.dflex_justify_align_items}>
                      {/* <label className={classes.dashboard_label}>Key Account Manager</label> */}
                      {/* <select name="leadKeyAccountManager" value={leadKeyAccountManager} onChange={handLeadKeyAccountManagerChange}>
                        <option value="All">All</option>
                        {leadSalesRepList.map((type) => (
                          <option key={type.userId} value={type.userId}>
                            {type.name}
                          </option>
                        ))}
                      </select> */}
                      <FormControl
                        variant="outlined"
                        className="custom-select-input"
                        size={"small"}
                        style={{ width: "150px" }}
                      >
                        <InputLabel id="leadKeyAccountManagerType">
                          {t("KEY_ACCOUNT_MANAGER")}
                        </InputLabel>
                        <Select
                          native
                          value={leadKeyAccountManager}
                          onChange={handLeadKeyAccountManagerChange}
                          name="leadKeyAccountManager"
                          label="Key Account Manager"
                          labelId="leadKeyAccountManagerType"
                          inputProps={{
                            id: "leadKeyAccountManager",
                          }}
                        >
                          <option value="All">All</option>
                          {leadSalesRepList.map((type) => (
                            <option key={type.userId} value={type.userId}>
                              {type.name}
                            </option>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  )}
                </>
              )}

              {portlet.id === "TotalCustomers" && (
                <>
                  {customerSalesRepList && customerSalesRepList.length > 0 && (
                    <div className={classes.dflex_justify_align_items}>
                      {/* <label className={classes.dashboard_label}>Key Account Manager</label> */}
                      {/* <select name="customerKeyAccountManager" value={customerKeyAccountManager} onChange={handCustomerKeyAccountManagerChange}>
                        <option value="All">All</option>
                        {customerSalesRepList.map((type) => (
                          <option key={type.userId} value={type.userId}>
                            {type.name}
                          </option>
                        ))}
                      </select> */}
                      <FormControl
                        variant="outlined"
                        className="custom-select-input"
                        size={"small"}
                        style={{ width: "150px" }}
                      >
                        <InputLabel id="customerKeyAccountManagerType">
                          {t("KEY_ACCOUNT_MANAGER")}
                        </InputLabel>
                        <Select
                          native
                          value={customerKeyAccountManager}
                          onChange={handCustomerKeyAccountManagerChange}
                          name="customerKeyAccountManager"
                          label="Key Account Manager"
                          labelId="customerKeyAccountManagerType"
                          inputProps={{
                            id: "customerKeyAccountManager",
                          }}
                        >
                          <option value="All">All</option>
                          {customerSalesRepList.map((type) => (
                            <option key={type.userId} value={type.userId}>
                              {type.name}
                            </option>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  )}

                  {salesProviderList.length > 0 && (
                    <div className={classes.dflex_justify_align_items}>
                      {/* <label className={classes.dashboard_label}>Tenant</label> */}
                      {/* <select name="salesProviderId" value={salesProviderId} onChange={handleSalesProviderIdChange}>
                          <option value="All">All</option>
                          {salesProviderList.map(t => (
                            <option key={t.tenantId} value={t.tenantId}>
                              {t.tenantName}
                            </option>
                          ))}
                        </select> */}
                      <FormControl
                        variant="outlined"
                        className="custom-select-input"
                        size={"small"}
                        style={{ width: "150px" }}
                      >
                        <InputLabel id="salesProviderIdType">
                          {t("TENANT")}
                        </InputLabel>
                        <Select
                          native
                          value={salesProviderId}
                          onChange={handleSalesProviderIdChange}
                          name="salesProviderId"
                          label="Tenant"
                          labelId="salesProviderIdType"
                          inputProps={{
                            id: "salesProviderId",
                          }}
                        >
                          <option value="All">All</option>
                          {salesProviderList.map((t) => (
                            <option key={t.tenantId} value={t.tenantId}>
                              {t.tenantName}
                            </option>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  )}
                </>
              )}

              {portlet.id === "TotalFulfillmentReq" && (
                <>
                  <div>
                    {/* <label className={classes.dashboard_label}>Tenant</label> */}
                    {tenantList.length > 0 && (
                      // <select name="assocTenantId" value={assocTenantId} onChange={handAssocTenantChange}>
                      //   <option value="All">All</option>
                      //   {tenantList.map(t => (
                      //     <option key={t.tenantId} value={t.tenantId}>
                      //       {t.tenantName}
                      //     </option>
                      //   ))}
                      // </select>
                      <FormControl
                        variant="outlined"
                        className="custom-select-input"
                        size={"small"}
                        style={{ width: "150px" }}
                      >
                        <InputLabel id="assocTenantIdType">
                          {t("TENANT")}
                        </InputLabel>
                        <Select
                          native
                          value={assocTenantId}
                          onChange={handAssocTenantChange}
                          name="assocTenantId"
                          label="Tenant"
                          labelId="assocTenantIdType"
                          inputProps={{
                            id: "assocTenantId",
                          }}
                        >
                          <option value="All">All</option>
                          {tenantList.map((t) => (
                            <option key={t.tenantId} value={t.tenantId}>
                              {t.tenantName}
                            </option>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  </div>
                </>
              )}

              {portlet.id === "TotalProducts" && tenantList.length > 0 && (
                <>
                  <div className={classes.dflex_justify_align_items}>
                    {/* <label className={classes.dashboard_label}>Tenant</label> */}
                    {/* <select name="assocTenantId" value={assocTenantId} onChange={handAssocTenantChange}>
                      <option value="All">All</option>
                      {tenantList.map(t => (
                        <option key={t.tenantId} value={t.tenantId}>
                          {t.tenantName}
                        </option>
                      ))}
                    </select> */}
                    <FormControl
                      variant="outlined"
                      className="custom-select-input"
                      size={"small"}
                      style={{ width: "150px" }}
                    >
                      <InputLabel id="assocTenantIdType">
                        {t("TENANT")}
                      </InputLabel>
                      <Select
                        native
                        value={assocTenantId}
                        onChange={handAssocTenantChange}
                        name="assocTenantId"
                        label="Tenant"
                        labelId="assocTenantIdType"
                        inputProps={{
                          id: "assocTenantId",
                        }}
                      >
                        <option value="All">All</option>
                        {tenantList.map((t) => (
                          <option key={t.tenantId} value={t.tenantId}>
                            {t.tenantName}
                          </option>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </>
              )}

              {portlet.id === "TotalOrdersClosed" && (
                <>
                  {ordersClosedSalesRepList &&
                    ordersClosedSalesRepList.length > 0 && (
                      <div className={classes.dflex_justify_align_items}>
                        {/* <label className={classes.dashboard_label}>Key Account Manager</label> */}
                        {/* <select name="salesRepUserId" value={salesRepUserId} onChange={handOrdersClosedSalesRepUserIdChange}>
                        <option value="All">All</option>
                        {ordersClosedSalesRepList.map((type) => (
                          <option key={type.userId} value={type.userId}>
                            {type.name}
                          </option>
                        ))}
                      </select> */}
                        <FormControl
                          variant="outlined"
                          className="custom-select-input"
                          size={"small"}
                          style={{ width: "150px" }}
                        >
                          <InputLabel id="salesRepUserIdType">
                            {t("KEY_ACCOUNT_MANAGER")}
                          </InputLabel>
                          <Select
                            native
                            value={salesRepUserId}
                            onChange={handOrdersClosedSalesRepUserIdChange}
                            name="salesRepUserId"
                            label="Key Account Manager"
                            labelId="salesRepUserIdType"
                            inputProps={{
                              id: "salesRepUserId",
                            }}
                          >
                            <option value="All">All</option>
                            {ordersClosedSalesRepList.map((type) => (
                              <option key={type.userId} value={type.userId}>
                                {type.name}
                              </option>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                    )}
                </>
              )}

              {portlet.id === "TerminatedOrders" && (
                <>
                  {tenantIdListForTermination.length > 0 && (
                    <div className={classes.dflex_justify_align_items}>
                      {/* <label className={classes.dashboard_label}>Tenant</label> */}
                      {/* <select name="tenantIdForTermination" value={tenantIdForTermination} onChange={handleTenantIdForTerminationChange}>
                        <option value="All">All</option>
                        {tenantIdListForTermination.map(t => (
                          <option key={t.tenantId} value={t.tenantId}>
                            {t.tenantName}
                          </option>
                        ))}
                      </select> */}
                      <FormControl
                        variant="outlined"
                        className="custom-select-input"
                        size={"small"}
                        style={{ width: "150px" }}
                      >
                        <InputLabel id="tenantIdForTerminationType">
                          {t("TENANT")}
                        </InputLabel>
                        <Select
                          native
                          value={tenantIdForTermination}
                          onChange={handleTenantIdForTerminationChange}
                          name="tenantIdForTermination"
                          label="Tenant"
                          labelId="tenantIdForTerminationType"
                          inputProps={{
                            id: "tenantIdForTermination",
                          }}
                        >
                          <option value="All">All</option>
                          {tenantIdListForTermination.map((t) => (
                            <option key={t.tenantId} value={t.tenantId}>
                              {t.tenantName}
                            </option>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  )}

                  {ordersTerminatedSalesRepList &&
                    ordersTerminatedSalesRepList.length > 0 && (
                      <div className={classes.dflex_justify_align_items}>
                        {/* <label className={classes.dashboard_label}>Key Account Manager</label> */}
                        {/* <select name="salesRepUserIdForTermination" value={salesRepUserIdForTermination} onChange={handOrdersTerminatedSalesRepUserIdChange}>
                        <option value="All">All</option>
                        {ordersTerminatedSalesRepList.map((type) => (
                          <option key={type.userId} value={type.userId}>
                            {type.name}
                          </option>
                        ))}
                      </select> */}
                        <FormControl
                          variant="outlined"
                          className="custom-select-input"
                          size={"small"}
                          style={{ width: "150px" }}
                        >
                          <InputLabel id="salesRepUserIdForTerminationType">
                            {t("KEY_ACCOUNT_MANAGER")}
                          </InputLabel>
                          <Select
                            native
                            value={salesRepUserIdForTermination}
                            onChange={handOrdersTerminatedSalesRepUserIdChange}
                            name="salesRepUserIdForTermination"
                            label="Key Account Manager"
                            labelId="salesRepUserIdForTerminationType"
                            inputProps={{
                              id: "salesRepUserIdForTermination",
                            }}
                          >
                            <option value="All">All</option>
                            {ordersTerminatedSalesRepList.map((type) => (
                              <option key={type.userId} value={type.userId}>
                                {type.name}
                              </option>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                    )}
                </>
              )}

              {portlet.id === "NewAccountAdditions" && (
                <>
                  {salesProviderIdForAccList.length > 0 && (
                    <div className={classes.dflex_justify_align_items}>
                      {/* <label className={classes.dashboard_label}>Tenant</label> */}
                      {/* <select name="salesProviderIdForAcc" value={salesProviderIdForAcc} onChange={handleProviderIdChange}>
                        <option value="All">All</option>
                        {salesProviderIdForAccList.map(t => (
                          <option key={t.tenantId} value={t.tenantId}>
                            {t.tenantName}
                          </option>
                        ))}
                      </select> */}
                      <FormControl
                        variant="outlined"
                        className="custom-select-input"
                        size={"small"}
                        style={{ width: "150px" }}
                      >
                        <InputLabel id="salesProviderIdForAccType">
                          {t("TENANT")}
                        </InputLabel>
                        <Select
                          native
                          value={salesProviderIdForAcc}
                          onChange={handleProviderIdChange}
                          name="salesProviderIdForAcc"
                          label="Tenant"
                          labelId="salesProviderIdForAccType"
                          inputProps={{
                            id: "salesProviderIdForAcc",
                          }}
                        >
                          <option value="All">All</option>
                          {salesProviderIdForAccList.map((t) => (
                            <option key={t.tenantId} value={t.tenantId}>
                              {t.tenantName}
                            </option>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  )}
                </>
              )}

              {portlet.id === "TotalPackageSold" && (
                <>
                  {tenantIdListForTotalPackage.length > 0 && (
                    <div className={classes.dflex_justify_align_items}>
                      <FormControl
                        variant="outlined"
                        className="custom-select-input"
                        size={"small"}
                        style={{ width: "150px" }}
                      >
                        <InputLabel id="assocTenantId">
                          {t("TENANT")}
                        </InputLabel>
                        <Select
                          native
                          value={assocTenantId}
                          onChange={handAssocTenantChange}
                          name="assocTenantId"
                          label="Tenant"
                          labelId="assocTenantId"
                          inputProps={{
                            id: "assocTenantId",
                          }}
                        >
                          <option value="All">All</option>
                          {tenantIdListForTotalPackage.map((t) => (
                            <option key={t.tenantId} value={t.tenantId}>
                              {t.tenantName}
                            </option>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  )}
                </>
              )}

              {portlet.id === "PartnerServicesCount" && (
                <>
                  {partnerList.length > 0 && (
                    <div className={classes.dflex_justify_align_items}>
                      <FormControl
                        variant="outlined"
                        className="custom-select-input"
                        size={"small"}
                        style={{ width: "150px" }}
                      >
                        <InputLabel id="partnerId">{t("PARTNERS")}</InputLabel>
                        <Select
                          native
                          value={partnerId}
                          onChange={handlePartnerChange}
                          name="partnerId"
                          label="Partners"
                          labelId="partnerId"
                          inputProps={{
                            id: "partnerId",
                          }}
                        >
                          {partnerList.map((t) => (
                            <option key={t.id} value={t.id}>
                              {t.name}
                            </option>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  )}
                </>
              )}

              {portlet.id === "PartnerOrderCount" && (
                <>
                  {partnerList.length > 0 && (
                    <div className={classes.dflex_justify_align_items}>
                      <FormControl
                        variant="outlined"
                        className="custom-select-input"
                        size={"small"}
                        style={{ width: "150px" }}
                      >
                        <InputLabel id="partnerId">{t("PARTNERS")}</InputLabel>
                        <Select
                          native
                          value={partnerId}
                          onChange={handlePartnerChange}
                          name="partnerId"
                          label="Partners"
                          labelId="partnerId"
                          inputProps={{
                            id: "partnerId",
                          }}
                        >
                          {partnerList.map((t) => (
                            <option key={t.id} value={t.id}>
                              {t.name}
                            </option>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  )}

                  {tenantList.length > 0 && (
                    <FormControl
                      variant="outlined"
                      className="custom-select-input"
                      size={"small"}
                      style={{ width: "150px" }}
                    >
                      <InputLabel id="tenantId">{t("TENANT")}</InputLabel>
                      <Select
                        native
                        value={tenantId}
                        onChange={handleTenantChange}
                        name="tenantId"
                        label="Tenant"
                        labelId="tenantId"
                        inputProps={{
                          id: "tenantId",
                        }}
                      >
                        {tenantList.map((t) => (
                          <option key={t.id} value={t.id}>
                            {t.name}
                          </option>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                </>
              )}
            </div>
            <h1 className={classes.count}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div style={{ flex: 1, minWidth: 0 }}>
                  <p
                    className={classes.graph_description}
                    style={{
                      marginBottom: "0",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    title={hasTwoCounts ? firstCountLabel : "\u00A0"}
                  >
                    {hasTwoCounts ? firstCountLabel : "\u00A0"}
                  </p>
                  <span style={{ display: "inline-flex" }}>
                    {count !== null
                      ? ["PartnersOrderTotal", "OverallCommission"].includes(
                          portlet.id,
                        )
                        ? currencyFormatter(count) || formatNumber(count)
                        : formatNumber(count)
                      : 0}
                  </span>
                </div>

                <div style={{ flex: 1, minWidth: 0 }}>
                  <p
                    className={classes.graph_description}
                    style={{
                      marginBottom: "0",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    title={hasTwoCounts ? secondCountLabel : "\u00A0"}
                  >
                    {hasTwoCounts ? secondCountLabel : "\u00A0"}
                  </p>
                  <span style={{ display: "inline-flex" }}>
                    {hasTwoCounts && secondCount !== null
                      ? ["PartnersOrderTotal", "OverallCommission"].includes(
                          portlet.id,
                        )
                        ? currencyFormatter(secondCount) || formatNumber(secondCount)
                        : formatNumber(secondCount)
                      : ""}
                  </span>
                </div>

                {additionalCount && (
                  <div
                    style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                      justifyContent: "center",
                    }}
                  >
                    {/* <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span className={classes.additional_count}>{t('ADDITIONS')}</span>
                        <span className={additions > 0 ? classes.additional_count_value_green : classes.additional_count_value}>
                          {additions > 0 ? `+${additions}` : additions}
                        </span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span className={classes.additional_count}>{t('CHURN')}</span>
                        <span className={churn < 0 ? classes.additional_count_value_red : classes.additional_count_value}>
                          {churn < 0 ? churn : (churn > 0 ? `-${churn}` : churn)}
                        </span>
                      </div>
                    </div> */}
                    <table>
                      <tbody>
                        <tr>
                          <td
                            style={{ lineHeight: "16px", textAlign: "right" }}
                          >
                            <span className={classes.additional_count}>
                              {t("ADDITIONS")}
                            </span>
                          </td>
                          <td
                            style={{
                              padding: 0,
                              textAlign: "right",
                              lineHeight: "16px",
                            }}
                          >
                            <span
                              className={
                                additions > 0
                                  ? classes.additional_count_value_green
                                  : classes.additional_count_value
                              }
                            >
                              {additions > 0 ? `+${additions}` : additions}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{ lineHeight: "16px", textAlign: "right" }}
                          >
                            <span className={classes.additional_count}>
                              {t("CHURN")}
                            </span>
                          </td>
                          <td
                            style={{
                              padding: 0,
                              textAlign: "right",
                              lineHeight: "16px",
                            }}
                          >
                            <span
                              className={
                                churn < 0
                                  ? classes.additional_count_value_red
                                  : classes.additional_count_value
                              }
                            >
                              {churn < 0
                                ? churn
                                : churn > 0
                                  ? `-${churn}`
                                  : churn}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </h1>
          </>
        ) : (
          <>
            <div className={classes.countRow}>
              <div>
                <p
                  className={
                    // classes.graph_name
                    classes.graph_description
                  }
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    color: "inherit",
                  }}
                >
                  {portlet.name}
                  {/* <Tooltip title={portlet.description} arrow>
                    <span style={{ display: 'inline-flex', alignItems: 'center', marginLeft: '4px', cursor: 'pointer' }}>
                      <InfoOutlinedIcon fontSize="small" style={{ color: 'inherit', fontSize: 16, verticalAlign: 'middle' }} />
                    </span>
                  </Tooltip> */}
                  <InfoWithMobilePopover description={portlet.description} />
                </p>
              </div>
              {/* {['PartnersOnboard', 'PartnersProducts', 'PartnersOrderTotal', 'OverallCommission'].includes(portlet.id) && (
                  <div className={classes.countContent}>
                    {portlet.id === 'PartnersOnboard' && <PartnersOnboard />}
                    {portlet.id === 'PartnersProducts' && <PartnersProducts />}
                    {portlet.id === 'PartnersOrderTotal' && <PartnersOrderTotal />}
                    {portlet.id === 'OverallCommission' && <OverallCommission />}
                  </div>
                )} */}
            </div>
            {/* <h1 className={classes.count}>
              <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <div style={{ width: '50%' }}>
                  <p className={classes.graph_description} style={{ marginBottom: '0' }}>{'\u00A0'}</p>
                  <span style={{ display: 'inline-flex' }}>
                    {count !== null
                      ? ['PartnersOrderTotal', 'OverallCommission'].includes(portlet.id)
                        ? currencyFormatter(count) || count
                        : count
                      : 0}
                  </span>
                </div>
              </div>
            </h1> */}
            <h1 className={classes.count}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div style={{ flex: 1, minWidth: 0 }}>
                  <p
                    className={classes.graph_description}
                    style={{
                      marginBottom: "0",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    title={hasTwoCounts ? firstCountLabel : "\u00A0"}
                  >
                    {hasTwoCounts ? firstCountLabel : "\u00A0"}
                  </p>
                  <span style={{ display: "inline-flex" }}>
                    {count !== null
                      ? [
                          "PartnersOrderTotal",
                          "OverallCommission",
                          "TotalProdRevenue",
                          "TenantSettlements",
                          "PartnerSettlements",
                        ].includes(portlet.id)
                        ? currencyFormatter(count) || formatNumber(count)
                        : formatNumber(count)
                      : 0}
                  </span>
                </div>
                {hasTwoCounts && (
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <p
                      className={classes.graph_description}
                      style={{
                        marginBottom: "0",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                      title={secondCountLabel}
                    >
                      {secondCountLabel}
                    </p>
                    <span style={{ display: "inline-flex" }}>
                      {secondCount !== null
                        ? [
                            "PartnersOrderTotal",
                            "OverallCommission",
                            "TotalProdRevenue",
                            "TenantSettlements",
                            "PartnerSettlements",
                          ].includes(portlet.id)
                          ? currencyFormatter(secondCount) || formatNumber(secondCount)
                          : formatNumber(secondCount)
                        : ""}
                    </span>
                  </div>
                )}

                {additionalCount && (
                  <div
                    style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <span className={classes.additional_count}>
                          {t("ADDITIONS")}
                        </span>
                        <span
                          className={
                            additions > 0
                              ? classes.additional_count_value_green
                              : classes.additional_count_value
                          }
                        >
                          {additions > 0 ? `+${additions}` : additions}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <span className={classes.additional_count}>
                          {t("CHURN")}
                        </span>
                        <span className={classes.additional_count_value_red}>
                          {churn < 0 ? churn : churn > 0 ? `-${churn}` : churn}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </h1>
          </>
        )}
      </div>
      {/* {loading && <Loader loading={loading} />} */}
    </div>
  );
};

export default RenderPortlet;
